import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Notification() {
    const [listProjectArray, setListProjectArray] = useState([]);
    const [linkOptionType, setLinkOptionType] = useState('');
    const [linkedProjectID, setLinkedProjectId] = useState('')
    const [selectedProjectName, setSelectedProjectName] = useState('')
    const [linkedTaskID, setLinkedTaskId] = useState('')
    const [selectedTaskName, setSelectedTaskName] = useState('')
    const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [membretype, setMembertype] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function setLinkOption(opt) {
        setLinkOptionType(opt)
        if (opt == 'project') {
            setLinkedTaskId('');
            setSelectedTaskName('');
            $('#optionproject').css('display', 'block');
        } else if (opt == 'task') {
            setLinkedProjectId('');
            setSelectedProjectName('')
            $('#optionproject').css('display', 'block');
            $('#optiontask').css('display', 'block');
        } else if (opt == 'notice') {
            setLinkedTaskId('');
            setSelectedTaskName('');
            setLinkedProjectId('');
            setSelectedProjectName('');
            $('#optionproject').css('display', 'none');
            $('#optiontask').css('display', 'none');
        }
    }

    const selectProjectId = (e) => {
        var trgval = e.target.value;
        var trgprojectname = e.target.options[e.target.selectedIndex].text;
        if (linkOptionType == 'project') {
            setLinkedProjectId(trgval);
            setSelectedProjectName(trgprojectname)
        } else if (linkOptionType == 'task') {
            getTaskListForProject(trgval);
        }

    }


    const selectTaskId = (e) => {
        var trgval = e.target.value;
        var trgtaskname = e.target.options[e.target.selectedIndex].text;
        setLinkedTaskId(trgval)
        setSelectedTaskName(trgtaskname);
    }

    function getTaskListForProject(proid) {
        var obj = {
            pro_id: proid
        }

        $.ajax({
            type: 'POST',
            url: 'getAllProjectTasks.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                if (res !== 'fail' && res !== '') {
                    var arr = res;
                    setListProjectTaskArrayy(arr);
                } else {
                    showAlert('Cannot found any task for this project.');
                    $('#norecord').css('display', 'block');
                }
            },
        });
    }

    function savenotifixcation() {
        var titletext = $('#notititle').val();
        var descriptiontext = $('#notidescription').val();
        var company_id = localStorage.getItem('mem_company_id');
        if (linkOptionType == '') {
            showAlert('Please select a notification purpose')
        } else if (titletext == '') {
            showAlert('Please insert a notification title')
        } else if (titletext == '') {
            descriptiontext('Please insert notification details')
        } else {

            var trgid = 0;
            var purpose_name = '';
            if (linkOptionType == 'project') {
                trgid = linkedProjectID;
                purpose_name = selectedProjectName;
            } else if (linkOptionType == 'task') {
                trgid = linkedProjectID;
                purpose_name = selectedTaskName;
            } else if (linkOptionType == 'notice') {
                trgid = 0;
                purpose_name = 'Notice'
            }
            var uniqueid = crypto.randomUUID();
            var creator_id = localStorage.getItem('member_id');

            var obj = {
                company_id: company_id,
                ref_id: trgid,
                type: linkOptionType,
                creator_name: localStorage.getItem('membername'),
                purpose: 'New team notification',
                purpose_name: purpose_name,
                project_id: linkedProjectID,
                task_id: linkedTaskID,
                goal_id: trgid,
                project_name: selectedProjectName,
                task_name: selectedTaskName,
                title: titletext,
                description: descriptiontext,
                unid: uniqueid,
                creator_id:creator_id
            }
            $.ajax({
                type: 'POST',
                url: 'add_custom_notifications.php',
                data: obj,
                cache: false,
                success: function (result) {

                    let res = typeof result === "string" ? JSON.parse(result) : result;

                    if (res.success) {
                        showAlert(res.message, 'success');


                    } else {
                        showAlert(res.message, 'error');
                    }
                }
            });
        }
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Generate Notification</h2>
                </div>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_two_third mt-50'>
                            <div className='vl_dsh_formnholder'>
                                <div className='formfield noborder autoheight normalview'>
                                    <label>Insert Notification Title</label>
                                    <input type="text" id="notititle" />
                                </div>
                                <div className='formfield noborder autoheight normalview'>
                                    <label>Insert Notification Description</label>
                                    <textarea className='nobackground blacktext' name="description" id="notidescription"></textarea>
                                </div>
                            </div>
                        </div>

                        <div className='vl_dsh_one_third mt-50'>
                            <div className='vl_dsh_formnholder'>
                                <div className='vl_dsh_one_full'>
                                    <div className='vl_dsh_one_full mt-15'>
                                        <div className='formfield noborder autoheight mt-15'>
                                            <label>Type of Notification</label>
                                            <input className='mr-5' type="radio" name="link_goal_to" value="project" onClick={() => { setLinkOption('project') }} />Select project
                                            <input className='mr-5 ml-10' type="radio" name="link_goal_to" value="Task" onClick={() => { setLinkOption('task') }} />Select task
                                            <input className='mr-5 ml-10' type="radio" name="link_goal_to" value="none" onClick={() => { setLinkOption('notice') }} />Team Notice
                                        </div>
                                        <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optionproject">
                                            <label>Select a project</label>
                                            <select name="selectproject" onChange={selectProjectId}>
                                                <option value="">Select a Project</option>
                                                {listProjectArray.map((project) => (
                                                    <option key={project.primary_key} value={project.primary_key}>
                                                        {project.pro_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optiontask">

                                            <label>Select a Task</label>
                                            <select name="selecttask" onChange={selectTaskId}>
                                                <option value="">Select a task</option>
                                                {listProjectTaskArray.map((task) => (
                                                    <option key={task.primary_key} value={task.primary_key}>
                                                        {task.taskname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_one_full mt-30'>
                            <div className='vl_dsh_buttonholder'>
                                <button className='pull_right mr-10' onClick={savenotifixcation}>Save</button>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
